import { render, staticRenderFns } from "./battle-box.vue?vue&type=template&id=5cb1a8e4&scoped=true"
import script from "./battle-box.vue?vue&type=script&lang=js"
export * from "./battle-box.vue?vue&type=script&lang=js"
import style0 from "./battle-box.vue?vue&type=style&index=0&id=5cb1a8e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb1a8e4",
  null
  
)

export default component.exports